import { useLPQuery } from '../lib/hooks/useLPQuery';
import type { NudgeModalConfigs } from '../components/Nudge/NudgeModal';
import { NudgeType } from '../components/Nudge/enums/NudgeType';

type UseNudgeTemplatesQueryProps = {
  nudgeConfigs: NudgeModalConfigs;
};

export function useNudgeTemplatesQuery({ nudgeConfigs }: UseNudgeTemplatesQueryProps) {
  const nudgeStatus: 'success' | 'fail' | undefined =
    nudgeConfigs.type === NudgeType.CONGRATS
      ? 'success'
      : nudgeConfigs.type === NudgeType.GUIDANCE
        ? 'fail'
        : undefined;

  const url: string = nudgeStatus
    ? `/nudgetemplates/behavior/${nudgeConfigs.behavior}/status/${nudgeStatus}`
    : `/nudgetemplates/training-completion`;

  return useLPQuery<{ payload: string }>(['NudgeTemplatesQuery', nudgeConfigs], url);
}
